"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconPositionRight = exports.iconPositionLeft = exports.autoCompleteOff = exports.defaultType = exports.inputTestId = exports.altText = exports.variantInline = exports.variantNaked = exports.classes = void 0;
var classes = {
  container: 'bds-textfield-container',
  label: 'bds-label',
  labelDisabled: 'bds-label-disabled',
  secondaryLabel: 'bds-secondary-label',
  helperText: 'bds-helper-text',
  helperTextDisabled: 'bds-helper-text-disabled',
  inputContainer: 'bds-input-container',
  inputContainerErrorBorder: 'bds-input-container-error-border',
  inputBox: 'bds-input-box',
  inputIcon: 'bds-input-icon',
  errorMsgText: 'bds-error-msg-text',
  variantNaked: 'bds-naked',
  variantInline: 'bds-inline',
  inputContainerFocus: 'bds-input-container-focus',
  inputBoxWrapper: 'bds-input-box-wrapper',
  iconBoxRight: 'bds-icon-box',
  iconBoxLeft: 'bds-icon-box-left',
  inputWithIcon: 'bds-input-with-icon',
  inputContainerDisabled: 'bds-input-container-disabled',
  inputBoxDisabled: 'bds-input-box-disabled',
  inputBoxReadOnly: 'bds-input-box-read-only'
};
exports.classes = classes;
var variantNaked = 'naked';
exports.variantNaked = variantNaked;
var variantInline = 'inline';
exports.variantInline = variantInline;
var altText = 'input-icon';
exports.altText = altText;
var inputTestId = 'input-test-id';
exports.inputTestId = inputTestId;
var defaultType = 'text';
exports.defaultType = defaultType;
var autoCompleteOff = 'off';
exports.autoCompleteOff = autoCompleteOff;
var iconPositionLeft = 'left';
exports.iconPositionLeft = iconPositionLeft;
var iconPositionRight = 'right';
exports.iconPositionRight = iconPositionRight;